import React from 'react';
import styled from 'styled-components';
import { Card, CardBody, CardSubhead, CardTitle } from '@spark/ui-components/components/Card';
import { formatNumero, formatPercentual } from '../utils/formatters';
import { getLojaLabel } from '../utils/lojaLabel';

const LojasForaJanelaCard = ({
  data,
  loading
}) => {
  const itens = (data || []).filter((item) => Number(item.foraJanela) > 0);

  return (
  <Card>
    <CardBody>
      <CardTitle>Lojas com mais chegadas fora da janela</CardTitle>
      <CardSubhead>Top 10 lojas por quantidade de chegadas fora da janela</CardSubhead>

      <ListArea>
        {loading ? (
          <EmptyState>Carregando metricas...</EmptyState>
        ) : itens.length === 0 ? (
          <EmptyState>Nenhum registro encontrado.</EmptyState>
        ) : (
          <ListTable>
            <thead>
              <tr>
                <th>Loja</th>
                <th className="numero">Chegadas fora</th>
                <th className="numero">%</th>
              </tr>
            </thead>
            <tbody>
              {itens.map((item) => (
                <tr key={item.id}>
                  <td title={getLojaLabel(item.loja)}>{getLojaLabel(item.loja)}</td>
                  <td className="numero">{formatNumero(item.foraJanela)}</td>
                  <td className="numero">{formatPercentual(item.percentual)}</td>
                </tr>
              ))}
            </tbody>
          </ListTable>
        )}
      </ListArea>
    </CardBody>
  </Card>
  );
};

const ListArea = styled.div`
  min-height: 270px;
  margin-top: 18px;
  overflow: auto;
`;

const ListTable = styled.table`
  width: 100%;
  font-size: 13px;
  color: #374151;

  th,
  td {
    padding: 6px 8px;
    border-bottom: 1px solid #eef0f3;
  }

  th {
    color: #4b5563;
    font-weight: 700;
  }

  .numero {
    text-align: right;
    white-space: nowrap;
  }
`;

const EmptyState = styled.div`
  width: 100%;
  height: 270px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  background: #f8f9fa;
  border: 1px dashed #d8dde3;
`;

export default LojasForaJanelaCard;
